<div
  class="a11y-trigger"
  #a11yTrigger
  [ngStyle]="triggerStyle"
  [class.is-dragging]="isDragging"
  (mousedown)="onDragStart($event)">
  <button
    nz-button
    nzType="text"
    class="a11y-toggle-btn"
    nz-tooltip
    nzTooltipTitle="Accessibility Settings (Ctrl+Shift+= to zoom in)"
    (click)="onToggleClick()"
    [attr.aria-expanded]="isPanelOpen"
    aria-label="Accessibility settings">
    <svg-icon
      src="/assets/icon/accessibility.svg"
      class="icon s-20"
      aria-hidden="true"
      aria-label="Accessibility">
    </svg-icon>
  </button>
</div>

<dialog
  #a11yDialog
  class="a11y-panel"
  [ngStyle]="dialogStyle"
  aria-label="Accessibility Settings Panel">
  <div class="a11y-panel-header">
    <span class="a11y-panel-title">Accessibility</span>
    <button
      nz-button
      nzType="text"
      class="a11y-close-btn"
      (click)="togglePanel()"
      aria-label="Close accessibility panel">
      ✕
    </button>
  </div>

  <div class="a11y-panel-section">
    <span class="a11y-section-label">Font Size</span>
    <div class="a11y-font-controls">
      <button
        nz-button
        nzType="default"
        class="a11y-btn"
        (click)="decreaseFontSize()"
        [disabled]="fontScalePercent <= 80"
        aria-label="Decrease font size">
        A-
      </button>
      <span class="a11y-font-percent" aria-live="polite">
        {{ fontScalePercent }}%
      </span>
      <button
        nz-button
        nzType="default"
        class="a11y-btn"
        (click)="increaseFontSize()"
        [disabled]="fontScalePercent >= 120"
        aria-label="Increase font size">
        A+
      </button>
      <button
        nz-button
        nzType="default"
        class="a11y-btn a11y-reset-btn"
        (click)="resetFontSize()"
        [disabled]="fontScalePercent === 100"
        aria-label="Reset font size to default">
        Reset
      </button>
    </div>
  </div>

  <div class="a11y-panel-section">
    <span class="a11y-section-label">Contrast</span>
    <div class="a11y-contrast-controls">
      <button
        nz-button
        nzType="default"
        class="a11y-btn a11y-contrast-btn"
        (click)="toggleContrast()"
        [attr.aria-label]="getContrastLabel()">
        {{ getContrastLabel() }}
      </button>
    </div>
  </div>

  <div class="a11y-panel-hint">
    <small>Keyboard: Ctrl+Shift+(+/-/0) for font size</small>
  </div>
</dialog>
